<template>
  <b-row>
    <b-col cols="12" sm="12" md="8">
      <b-card no-header>
        <template slot="header">
          <i class="fa fa-user"></i> Editar Usuario:
        </template>
        <b-card v-if="registro_no_encontrado">
          <div slot="header">
            <strong>Usuario no encontrado</strong>
          </div>
        </b-card>
        <form v-else>
          <b-row>
            <b-col cols="10" col sm="2">
              <b-form-group label="* Usuario:">
                <b-form-input type="text" readonly v-model.trim="user.username" placeholder="Usuario"
                              :class="{'is-valid': !errores.username, 'is-invalid': errores.username}"/>
                <b-form-invalid-feedback v-if="errores.username">{{ errores.username }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="10" col sm="4">
              <b-form-group label="* Nombre:">
                <b-form-input type="text" v-model.trim="user.nombre" placeholder="Nombre"
                              :class="{'is-valid': !errores.nombre, 'is-invalid': errores.nombre}"/>
                <b-form-invalid-feedback v-if="errores.nombre">{{ errores.nombre }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="10" col sm="4">
              <b-form-group label="* Email:">
                <b-form-input type="email" v-model.trim="user.email"
                              :class="{'is-valid': !errores.email, 'is-invalid': errores.email}" placeholder="Email"/>
                <b-form-invalid-feedback v-if="errores.email">{{ errores.email }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10" col sm="3">
              <b-form-group label="Rol:">
                <b-form-select v-model="user.rol_id" :options="roles"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="10" col sm="3">
              <b-form-group label="Autorizar Comprobantes:">
                <b-form-select v-model="user.autoriza_comprobantes" :options="sino"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="10" col sm="3">
              <b-form-group label="Cerrar Meses:">
                <b-form-select v-model="user.cerrar_mes" :options="sino"></b-form-select>
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col cols="10" col sm="3">
              <b-form-group label="Password:">
                <b-form-input type="password" v-model.trim="password" autocomplete="off"
                              placeholder="Password (Dejar vacio si no se desea cambiar)"
                              :class="{'is-valid': password.length >= 6, 'is-invalid':error_pass}"
                />
              </b-form-group>
            </b-col>
          </b-row>

        </form>
        <template slot="footer">
          <b-button @click="goBack" class="bnt btn-info text-light"><i class="fa fa-arrow-left"></i> Regresar</b-button>
          <b-button v-show="!registro_no_encontrado" @click="guardar" class="ml-3 bnt btn-success text-light"><i
            class="fa fa-save"></i> Guardar
          </b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import toastr from "toastr";

  export default {
    name: 'User',
    data: () => {
      return {
        id: '',
        password: '',
        error_pass:false,
        errores:{},
        user: {},
        registro_no_encontrado: false,
        roles:[
          { value: '1', text: 'SisAdmin' },
          { value: '2', text: 'Contador' },
          { value: '3', text: 'Auxiliar' },

        ],
        sino: [
          { value: 1, text: "Si" },
          { value: 0, text: "No" }
        ],
      }
    },
    mounted() {
      this.getUser()
    },
    methods: {
      goBack() {
        //this.$router.go(-1)
        this.$router.replace({path: '/users'});
      },
      async guardar() {
        this.error_pass=false;
        if (this.user.username == '' || this.user.email == '' || this.user.nombre == '')
          return toastr["error"]("Completar campos requeridos (*)");

        if (this.password !== '' && this.password.length < 6)
          return toastr["warning"]("Usar contraseña de 6 o más carácteres");

        var regex = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#])[A-Za-z\d$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#]{6,30}$/
        );
        if (this.password !== '' && !regex.test(this.password)) {
          this.error_pass=true;
          toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: true,
            positionClass: "toast-top-right",
            preventDuplicates: true,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "10000",
            extendedTimeOut: "15000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
          };
          return toastr["error"](`🤨 Se requiere: por lo menos una letra en <strong>Mayúscula</strong>, un <strong>Número</strong> y un <strong>Carácter Especial</strong>
                    (Ejem: ?&\\"{[-+$@!%*_,};].!|¬°´?#])`, "Favor Usar Contraseñas Seguras");
        }
        try {
          if(this.password.toString().length) this.user.password = this.password;
          // eslint-disable-next-line no-undef
          let {data} = await axios.put("/api/usuarios/" + this.id, this.user);
          if (data.status == 'ok') {
            this.$swal({
              toast: true,
              position: "top-end",
              html:
                '<span class="text-success"> Usuario Actualizado Correctamente</span>',
              type: "success",
              showConfirmButton: false,
              timer: 2000
            });
            this.$router.replace({path: '/users'})
          } else {
            this.errores=data.errors;
            toastr["error"]("Verifique");
          }

        } catch (error) {console.log(error);}

      },
      async getUser() {
        this.id = parseInt(this.$route.params.id);
        try {
          // eslint-disable-next-line no-undef
          let {data} = await axios.get("/api/usuarios/" + this.id);
          if (data) this.user = data;
          else this.registro_no_encontrado = true;
        } catch (error) {console.log(error);}
      }
    }
  }
</script>
